import React from 'react';
import PropTypes from 'prop-types';
/* Styles */
import './empty-content.scss';

class EmptyContent extends React.PureComponent {
  render() {
    return (
      <div className={`glu-empty-content ${this.props.centered && 'glu-flex'}`}>
        <span className="g-icon g-icon-info" />
        <div className="text-secondary text-bold">{this.props.title}</div>
        <div className="text-secondary text-bold">{this.props.info}</div>
      </div>
    );
  }
}

EmptyContent.propTypes = {
  title: PropTypes.string,
  info: PropTypes.string,
  centered: PropTypes.bool,
};

EmptyContent.defaultProps = {
  title: '',
  info: '',
  centered: true,
};

export default EmptyContent;
